export async function uploadToCloudinary(file, retries = 3) {
  // Fallback to your cloud name if env var not set
  const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || "dzngpgki4";
  // Fallback to your upload preset if env var not set
  const uploadPreset = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || "farmnet";
  
  // Validate file
  if (!file) {
    throw new Error("No file provided for upload");
  }

  // Validate file type
  const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
  if (!validTypes.includes(file.type)) {
    throw new Error(`Unsupported file type: ${file.type}`);
  }

  // Validate file size (10MB max)
  const maxSize = 10 * 1024 * 1024; // 10MB
  if (file.size > maxSize) {
    throw new Error(`File too large (max ${maxSize/1024/1024}MB)`);
  }

  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', uploadPreset);
  formData.append('cloud_name', cloudName);

  let lastError;
  
  for (let i = 0; i < retries; i++) {
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 30000); // 30s timeout
      
      const response = await fetch(
        `https://api.cloudinary.com/v1_1/${cloudName}/upload`,
        {
          method: 'POST',
          body: formData,
          signal: controller.signal
        }
      );

      clearTimeout(timeoutId);

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || `Upload failed with status ${response.status}`);
      }

      const data = await response.json();
      return data;
      
    } catch (error) {
      lastError = error;
      console.warn(`Upload attempt ${i + 1} failed:`, error.message);
      
      // Wait before retrying (exponential backoff)
      if (i < retries - 1) {
        await new Promise(resolve => setTimeout(resolve, 1000 * Math.pow(2, i)));
      }
    }
  }

  console.error('Final upload error after retries:', {
    error: lastError.message,
    file: file.name,
    size: file.size,
    type: file.type
  });
  
  throw new Error(`Upload failed after ${retries} attempts: ${lastError.message}`);
}